import Accordion from "components/Accordion";
import { HAULPAY_FAQ_LIST } from "constants/help";
import styles from "./style.module.scss";

export default function HaulPayFAQ() {
  return (
    <div className={styles.haulPayFAQContainer}>
      <span className="text-primary">Common Help Questions</span>
      <span className="font-light">NOAs and Invoices:</span>

      <div className={styles.accordionContainer}>
        {HAULPAY_FAQ_LIST.map((item) => (
          <Accordion key={item.id} data={item} />
        ))}
      </div>
    </div>
  );
}
